import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quotesAdapter = getAdapter();

const quotesSlice = createSlice({
  name: 'quotes',
  initialState: quotesAdapter.getInitialState(),
  reducers: {
    setQuotes: (state, { payload: { quotes } }) => {
      quotesAdapter.setAll(state, quotes);
    },
  },
});

const selectors = quotesAdapter.getSelectors(({ quotes }) => quotes);

export const getQuotes = (state) => selectors.selectAll(state);

export const {
  setQuotes,
} = quotesSlice.actions;

export default quotesSlice.reducer;
